// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import "url-search-params-polyfill";
import Vue from "vue";
import "default-passive-events";
import "@/assets/scss/reset.scss";
import "@/assets/scss/common.scss";

Vue.config.productionTip = false;
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";

Vue.use(ElementUI, { size: "mini" });
Vue.prototype.$message = ElementUI.Message;

import axios from "@/utils/request.js";

Vue.prototype.$axios = axios;
import mceEditor from "@/components/editor/index.vue";
import iTags from "@/components/tags/index.vue";
import iTable from "@/components/table/index.vue";

Vue.component("c-mce-editor", mceEditor);
Vue.component("i-tags", iTags);
Vue.component("i-table", iTable);
import destoryVm from "@/utils/destory-popup";
import richText from "./components/rich-text/index";
import page from "./components/page/index.vue";
// 注册全局弹窗实例列表
Vue.component("page", page);
import CSelect from "./components/select/index.vue";

Vue.component("c-select", CSelect);
import tableName from "./components/table-name/index.vue";

Vue.component("c-table-header", tableName);

import "./directive/limit";
import "./directive/dic";
import VueDirectiveImagePreviewer from "./directive/img-preview/index.js";

Vue.use(VueDirectiveImagePreviewer);

import tableButton from "./components/button-text/index.vue";

Vue.component("el-button", tableButton);

import * as filters from "./filters/index";

Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// 浏览器回退时候的实例处理
window.addEventListener("popstate", () => {
  destoryVm();
});

Vue.component("rich-text", richText);
import App from "./App";
import router from "./router";
import store from "./store";
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});

window.onerror = (msg, url, num) => {
  if (msg === "Uncaught SyntaxError: Unexpected token <" && num === 1) {
    location.reload();
  }
};



// WEBPACK FOOTER //
// ./src/main.js